export function stringifyScopes(scopes: string | string[]): string {
    return Array.isArray(scopes) ? scopes.join(' ') : scopes;
}
